import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import AgentNavbar from "../../component/AgentNavbar";
import { baseurl } from "../../component/Baseurl";
import { MapPin, AlertCircle } from "react-feather";
import Footer from "../../component/Footer";
import { useNavigate } from "react-router-dom";


function HotelRoomBook() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ResultToken = queryParams.get("ResultToken");
  const RoomUniqueId = queryParams.get("RoomUniqueId");

  const [roomData, setRoomData] = useState(null);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
 

  const [mrp, setMrp] = useState("");
  const [price, setPrice] = useState("");
  const [tax, setTax] = useState("");
  // const [adminMarkup, setAdminMarkup] = useState(0);
  // const [distributorMarkup, setDistributorMarkup] = useState(0);
  const [hotelAmount, setHotelAmount] = useState(0);
  
  const agentid = localStorage.getItem("agent_id") || '2';

  // console.log("agent id",agentid );

  console.log("agent ID : ", agentid);
  const [hotelMarkup, setHotelMarkup] = useState(0); // Initialize with 0
  // const [roomData, setRoomData] = useState(null);
  const [formData, setFormData] = useState([]);
  // const [formData, setFormData] = useState({
  //   title: "",
  //   firstName: "",
  //   middleName: "",
  //   lastName: "",
  //   phoneNo: "",
  //   email: "",
  //   age: "",
  //   mrp: "",
  //   price: "",
  //   tax: "",
  //   admin_markup: "",
  //   distributor_markup: "",
  //   agent_markup: "",
  // });
  
  // const handleChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // };
  

  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(true); 
  // const [transactions, setTransactions] = useState([]);
  useEffect(() => {
    if (!agentid) {
      setError("Agent ID not found in local storage.");
      setLoading(false);
      return;
    }

    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${baseurl}/GetWalletTransactionsForAgent/${agentid}`);
        // setTransactions(response.data.transactions);
        setWalletBalance(response.data.wallet_balance);

        console.log(walletBalance);
      } catch (error) {
        setError("Failed to fetch wallet transactions. Please try again.");
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [agentid]);



  const handleChange = (index, field, value) => {
    const updatedFormData = [...formData];
    updatedFormData[index][field] = value;
    setFormData(updatedFormData);
  };
  const [travelers, setTravelers] = useState([]);





  const [adminMarkup, setAdminMarkup] = useState(0);
  const [distributorMarkup, setDistributorMarkup] = useState(0);
  const [agentMarkup, setAgentMarkup] = useState(0);
  const [agentCashback, setAgentCashback] = useState(0);


  
  useEffect(() => {
    if (!agentid) return console.error("No agent ID found in localStorage");
  
    const fetchMarkupDetails = async () => {
      try {
        const { data } = await axios.get(`${baseurl}getMarkupDetailsById/${agentid}`);
  
        if (data?.message === "Markup details fetched successfully") {
          setAdminMarkup(Number(data.adminMarkup.admin_hotel_markup) || 0);
          setAgentCashback(Number(data.adminMarkup.agent_hotel_markup) || 0);
          setDistributorMarkup(Number(data.distributorMarkup.distributor_hotel_markup) || 0);
          setAgentMarkup(Number(data.agentMarkup.hotel_markup_amount) || 0);
          const totalMarkup = (Number(data.adminMarkup.admin_hotel_markup) || 0) + (Number(data.agentMarkup.hotel_markup_amount) || 0);
  
          console.log("Hotel Markup Amount:", totalMarkup);
          setHotelMarkup(totalMarkup); // Update state correctly

          console.log("setAgentCashback:", agentCashback);


          console.log("Hotel Markups:", {
            admin: data.adminMarkup.admin_hotel_markup,
            distributor: data.distributorMarkup.distributor_hotel_markup,
            agent: data.agentMarkup.hotel_markup_amount
          });
        } else {
          console.error("Unexpected API response", data);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };
  
    fetchMarkupDetails();
  }, [agentid]);




  // ✅ Fetch markup details from API
  useEffect(() => {
    if (ResultToken && RoomUniqueId) {
      const apiUrl = `${baseurl}block-room`;
  
      axios
        .post(apiUrl, { ResultToken, RoomUniqueId })
        .then((response) => {
          console.log("Response from backend:", response.data);
          setRoomData(response.data);
  
          const hotelRoom = response.data?.BlockRoom?.BlockRoomResult?.HotelRoomsDetails?.[0]?.Price;
          const adultCount = response.data?.BlockRoom?.BlockRoomResult?.HotelRoomsDetails?.[0]?.rooms?.[0]?.rates?.[0]?.adult || 0;
          const childCount = response.data?.BlockRoom?.BlockRoomResult?.HotelRoomsDetails?.[0]?.rooms?.[0]?.rates?.[0]?.children || 0;
  
          if (hotelRoom) {
            setMrp(hotelRoom.PublishedPrice || "");
            setPrice(hotelRoom.OfferedPriceRoundedOff || "");
            setTax(
              (hotelRoom.Tax || 0) +
              (hotelRoom.ServiceTax || 0) +
              (hotelRoom.GSTPrice || 0)
            );
          }
  
          // Generate default traveler fields
          const travelerData = [];
  
          for (let i = 1; i <= adultCount; i++) {
            travelerData.push({
              type: "Adult",
              title: "",
              firstName: "",
              middleName: "",
              lastName: "",
              phoneNo: "",
              email: "",
              age: "",
            });
          }
  
          for (let i = 1; i <= childCount; i++) {
            travelerData.push({
              type: "Child",
              title: "",
              firstName: "",
              middleName: "",
              lastName: "",
              phoneNo: "",
              email: "",
              age: "",
            });
          }
  
          setTravelers(travelerData);
        })
        .catch((error) => {
          console.error("Error fetching data from backend:", error);
        });
    }
  }, [ResultToken, RoomUniqueId]);
  
 


  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const updatedFormData = {
      travelers,
      mrp,
      price,
      tax,
      agentCashback,
      admin_markup: adminMarkup, // ✅ Use state values instead of `data`
      distributor_markup: distributorMarkup, // ✅ Use state values
      agent_markup: agentMarkup, // ✅ Use state values
      ResultToken: queryParams.get("ResultToken"),
      RoomUniqueId: queryParams.get("RoomUniqueId"),
      agentid,
    };
  
    console.log("Form data being sent:", updatedFormData);
  
    try {
      const response = await axios.post(`${baseurl}commitBooking`, updatedFormData, {
        headers: { "Content-Type": "application/json" },
      });
  
      console.log("Response data:", response.data);
      if (response.status === 201) {
        navigate(`/pay_hotel/${response.data.booking_id}`);
      } else {
        alert("Form submission failed");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  

  const handleTravelerChange = (index, field, value) => {
    setTravelers(prevTravelers => {
      const updatedTravelers = [...prevTravelers];
      updatedTravelers[index][field] = value;
      return updatedTravelers;
    });
  };
  




  // useEffect(() => {
  //   if (ResultToken && RoomUniqueId) {
  //     const apiUrl = `${baseurl}block-room`;

  //     axios
  //       .post(apiUrl, { ResultToken, RoomUniqueId })
  //       .then((response) => {
  //         console.log("Response from backend:", response.data);
  //         setRoomData(response.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error sending data to backend:", error);
  //         setError(error.message);
  //       });
  //   }
  // }, [ResultToken, RoomUniqueId]);




  // const totalPrice = (Number(roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0].Price.OfferedPriceRoundedOff) || 0) + hotelMarkup;
  const totalPrice = 
  (Number(roomData?.BlockRoom?.BlockRoomResult?.HotelRoomsDetails?.[0]?.Price?.OfferedPriceRoundedOff) || 0) + 
  (hotelMarkup || 0);


  return (
    <>
      <AgentNavbar />
      <form onSubmit={handleSubmit}>
      <div className="container-fluid py-4 secbg1">
        {/* <h3>Hotel Room Booking</h3>
        <div>ResultToken: {ResultToken}</div>
        <div>RoomUniqueId: {RoomUniqueId}</div> */}
 
        {error && <div style={{ color: "red" }}>Error: {error}</div>}

        {roomData && roomData.Status === 1 ? (
          <div>
            <div className="bhj">
              <div className="container my-4">
                <div className="row g-3">
                  <div className="col-md-8">
                    <div className=" bg-white p-3 border rounded text-start">
                      <h1 className="roomnm mb-3">
                        {
                          roomData.BlockRoom.BlockRoomResult
                            .HotelRoomsDetails[0].RoomTypeName
                        }
                      </h1>

                      <div className="d-flex">
                        <div className="mnjkaax me-2">
                          <img
                            src={
                              roomData.BlockRoom.BlockRoomResult
                                .HotelRoomsDetails[0].HotelImage
                            }
                            className="img-fluid"
                            alt={
                              roomData.BlockRoom.BlockRoomResult
                                .HotelRoomsDetails[0].RoomTypeName
                            }
                          />
                        </div>

                        <div>
                          <div className="mb-3">
                            <MapPin size={16} />
                            &nbsp;
                            {
                              roomData.BlockRoom.BlockRoomResult
                                .HotelRoomsDetails[0].Address
                            }
                          </div>

                          <div>
                            <div
                              onClick={() => setShowModal(true)}
                              style={{ cursor: "pointer" }}
                              className="iZHNjh"
                            >
                              Cancellation Policies <AlertCircle size={15} />
                            </div>

                            {showModal && (
                              <div
                                className="modal-overlay"
                                onClick={() => setShowModal(false)}
                              >
                                <div
                                  className="modal-content"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="kma1 text-start mb-2">
                                    Cancellation Policy:
                                  </div>
                                  <ul className="kma">
                                    {roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0].CancellationPolicy.split(
                                      " | "
                                    )
                                      .map((policy) => policy.trim()) // Remove extra spaces
                                      .filter((policy) => policy.length > 0) // Ensure only non-empty policies are printed
                                      .map((policy, index) => (
                                        <li
                                          key={index}
                                          className="kma text-start"
                                        >
                                          {index + 1}. {policy}
                                        </li>
                                      ))}
                                  </ul>

                                  <div className="text-start kma mb-3">
                                    <strong>
                                      Last Cancellation Available Till:
                                    </strong>{" "}
                                    {
                                      roomData.BlockRoom.BlockRoomResult
                                        .HotelRoomsDetails[0]
                                        .LastCancellationDate
                                    }
                                  </div>

                                  <div className="text-start kma">
                                    <strong>Is PAN Mandatory:</strong>{" "}
                                    {roomData.BlockRoom.BlockRoomResult
                                      .HotelRoomsDetails[0].IsPANMandatory
                                      ? "Yes"
                                      : "No"}
                                  </div>
                                  <div className="text-start kma">
                                    <strong>Is Passport Mandatory:</strong>{" "}
                                    {roomData.BlockRoom.BlockRoomResult
                                      .HotelRoomsDetails[0].IsPassportMandatory
                                      ? "Yes"
                                      : "No"}
                                  </div>
                                  <div className="text-start kma">
                                    <strong>No. of PAN Required:</strong>{" "}
                                    {
                                      roomData.BlockRoom.BlockRoomResult
                                        .HotelRoomsDetails[0].NoOfPANRequired
                                    }
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="mt-5">
  <div className="row g-2">
    {travelers.map((traveler, index) => (
      <div key={index} className="col-md-12 mb-3">
        <h5>{traveler.type} {index + 1}</h5>

        <div className="row">
        <div className="col-md-2 mb-1">
  <label htmlFor={`title-${index}`} className="form-label">Title</label>
  <select
    className="form-control input-field"
    id={`title-${index}`}
    name={`title-${index}`}
    value={traveler.title}
    onChange={(e) => handleTravelerChange(index, "title", e.target.value)}
    required
  >
    <option value="">Select Title</option>
    <option value="Mr">Mr</option>
    <option value="Mrs">Mrs</option>
    <option value="Master">Master</option>
    <option value="Miss">Miss</option>
    <option value="Dr">Dr</option>
    <option value="Prof">Prof</option>
  </select>
</div>


          <div className="col-md-4 mb-1">
            <label htmlFor={`firstName-${index}`} className="form-label">First Name</label>
            <input type="text" className="form-control input-field" id={`firstName-${index}`} name={`firstName-${index}`} value={traveler.firstName} onChange={(e) => handleTravelerChange(index, "firstName", e.target.value)} placeholder="Enter first name" required />
          </div>

          <div className="col-md-4">
            <label htmlFor={`middleName-${index}`} className="form-label">Middle Name</label>
            <input type="text" className="form-control input-field" id={`middleName-${index}`} name={`middleName-${index}`} value={traveler.middleName} onChange={(e) => handleTravelerChange(index, "middleName", e.target.value)} placeholder="Enter middle name" />
          </div>

          <div className="col-md-4">
            <label htmlFor={`lastName-${index}`} className="form-label">Last Name</label>
            <input type="text" className="form-control input-field" id={`lastName-${index}`} name={`lastName-${index}`} value={traveler.lastName} onChange={(e) => handleTravelerChange(index, "lastName", e.target.value)} placeholder="Enter last name" required />
          </div>

          <div className="col-md-4">
            <label htmlFor={`phoneNo-${index}`} className="form-label">Phone No</label>
            <input type="text" className="form-control input-field" id={`phoneNo-${index}`} name={`phoneNo-${index}`} value={traveler.phoneNo} onChange={(e) => handleTravelerChange(index, "phoneNo", e.target.value)} placeholder="Enter phone number" required />
          </div>

          <div className="col-md-4">
            <label htmlFor={`email-${index}`} className="form-label">Email</label>
            <input type="text" className="form-control input-field" id={`email-${index}`} name={`email-${index}`} value={traveler.email} onChange={(e) => handleTravelerChange(index, "email", e.target.value)} placeholder="Enter email" required />
          </div>

          <div className="col-md-2">
            <label htmlFor={`age-${index}`} className="form-label">Age</label>
            <input type="text" className="form-control input-field" id={`age-${index}`} name={`age-${index}`} value={traveler.age} onChange={(e) => handleTravelerChange(index, "age", e.target.value)} placeholder="Enter age" required />
          </div>
        </div>
      </div>
    ))}
  </div>

  

{walletBalance > totalPrice ? (
  <button type="submit" className="btn btn-primary mt-3" onClick={handleSubmit}>
    Book Now
  </button>
) : (
  <a href="/agent/request-top-up" className="btn btn-warning mt-3 text-dark">
    Insufficent Fund. Request Top-Up
  </a>
)}



</div>


                   


                    </div>
                  </div>
                  <div className="col-md-4 ">

<div className="box_prie1">
<div className="sum1 w100 p-3 text-white text-center">
                      <div className="text-center">
                        Hotel Room Booking Summary
                      </div>
                    </div>
                    <div className="bg-white border rounded p-3 text-start">
                      <div className="text-start romname1 mb-1">
                        Room Name.:{" "}
                        {
                          roomData.BlockRoom.BlockRoomResult
                            .HotelRoomsDetails[0].RoomTypeName
                        }
                      </div>

                      <div className="pubprice">
                        {roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0]
                          .Price.CurrencyCode === "INR"
                          ? "₹"
                          : roomData.BlockRoom.BlockRoomResult
                              .HotelRoomsDetails[0].Price.CurrencyCode}

{(Number(roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0].Price.PublishedPrice) || 0) + hotelMarkup}          
                        {/* {roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0].Price.PublishedPrice} */}
                      </div>

                      <div className="offerprice">
                        {roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0]
                          .Price.CurrencyCode === "INR"
                          ? "₹"
                          : roomData.BlockRoom.BlockRoomResult
                              .HotelRoomsDetails[0].Price.CurrencyCode}


{(Number(roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0].Price.OfferedPriceRoundedOff) || 0) + hotelMarkup}          

{/* {roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0].Price.OfferedPriceRoundedOff} */}
                      </div>

                      <div className="taxfee">
                        +{" "}
                        {roomData.BlockRoom.BlockRoomResult.HotelRoomsDetails[0]
                          .Price.CurrencyCode === "INR"
                          ? "₹"
                          : roomData.BlockRoom.BlockRoomResult
                              .HotelRoomsDetails[0].Price.CurrencyCode}{" "}

 


                        {(roomData.BlockRoom.BlockRoomResult
                          .HotelRoomsDetails[0].Price.Tax || 0) +
                          (roomData.BlockRoom.BlockRoomResult
                            .HotelRoomsDetails[0].Price.ServiceTax || 0) +
                          (roomData.BlockRoom.BlockRoomResult
                            .HotelRoomsDetails[0].Price.GSTPrice || 0)}
                            
                            {" "}
                        taxes & fees
                      </div>

                      <div className="prnght m-0">
                        Per Night /{" "}
                        {
                          roomData.BlockRoom.BlockRoomResult
                            .HotelRoomsDetails[0].room_only
                        }
                      </div>

                      <div className="prnght1 m-0">
                        {
                          roomData.BlockRoom.BlockRoomResult
                            .HotelRoomsDetails[0]?.rooms?.[0]?.rates?.[0]?.rooms
                        }{" "}
                        Room(s),
                        {
                          roomData.BlockRoom.BlockRoomResult
                            .HotelRoomsDetails[0]?.rooms?.[0]?.rates?.[0]?.adult
                        }{" "}
                        Adult(s),
                        {
                          roomData.BlockRoom.BlockRoomResult
                            .HotelRoomsDetails[0]?.rooms?.[0]?.rates?.[0]
                            ?.children
                        }{" "}
                        Child(ren)
                      </div>
                    </div>
</div>

                    
                    
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center vh-100  text-white">
            <span class="loader1"><span className="text-white"></span></span>
            </div>
        )}
        

       

        
      </div>

      </form>
    </>
  );
}

export default HotelRoomBook;
